import { ChakraProps } from '@chakra-ui/react';

// hide element while preserving width
const hiddenStyle: ChakraProps = { visibility: 'hidden', h: 0 };

export { hiddenStyle };
